import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import axios from 'axios';
import { axiosPath, path } from '@/routing/helpers/router';
import * as currentPageAction from '@/store/actions/currentPageAction';
import useIsMounted from '@/layout/components/hooks/useIsMounted';

export default function ImpersonateScreen() {
  const { challenge } = useParams();
  const navigate = useNavigate();
  const isMounted = useIsMounted();
  const dispatch = useDispatch();

  const handleImpersonate = async () =>
    axios
      .post(axiosPath('api_r_open_impersonate', open), { challenge })
      .then(async ({ data }) => {
        if (isMounted.current) {
          await localStorage.setItem('t', data.token);
          await localStorage.setItem('rt', data.refresh_token);
          dispatch(currentPageAction.change('recentlyLoggedIn', true, true));
          navigate(
            path({
              name: 'user_home',
            }),
          );
        }
      })
      .catch((e) => {
        navigate(
          path({
            name: 'user_login',
          }),
        );
      });

  useEffect(() => {
    handleImpersonate();
  }, []);

  return <></>;
}
